import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NetSheetPageModule } from '../net-sheet/net-sheet.module';
import { PITIPageModule } from '../piti/piti.module';
import { ComparableSalesPageModule } from './comparable-sales/comparable-sales.module';
import { DetailsPageModule } from './details/details.module';
import { HomePageModule } from './home/home.module';
import { MapViewPageModule } from './map-view/map-view.module';
import { ReportPageModule } from './report/report.module';
import { SaleInformationPageModule } from './sale-information/sale-information.module';
import { SchoolsPageModule } from './schools/schools.module';
import { TransactionHistoryPageModule } from './transaction-history/transaction-history.module';

const routes: Routes = [
  {
    loadChildren: () => HomePageModule,
    path: ':id'
  },
  {
    loadChildren: () => DetailsPageModule,
    path: ':id/details'
  },
  {
    loadChildren: () => TransactionHistoryPageModule,
    path: ':id/transaction-history'
  },
  {
    loadChildren: () => SaleInformationPageModule,
    path: ':id/sale-information'
  },
  {
    loadChildren: () => SchoolsPageModule,
    path: ':id/schools'
  },
  {
    loadChildren: () => MapViewPageModule,
    path: ':id/map-view'
  },
  {
    loadChildren: () => ComparableSalesPageModule,
    path: ':id/comparable-sales'
  },
  {
    loadChildren: () => NetSheetPageModule,
    path: ':id/net-sheet'
  },
  {
    loadChildren: () => PITIPageModule,
    path: ':id/piti'
  },
  {
    loadChildren: () => ReportPageModule,
    path: ':id/report'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ProfilePageRoutingModule {}
